import { useRef } from "react";
import { Box } from "@mui/material";

import { grayLight } from "design-system/colors";

type EmailPreviewProps = {
  htmlContent: string;
};

const EmailPreview = ({ htmlContent }: EmailPreviewProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  return (
    <Box
      sx={{
        border: `1px solid ${grayLight}`,
        borderRadius: 1,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <iframe
        ref={iframeRef}
        srcDoc={htmlContent}
        style={{
          width: "100%",
          height: "400px",
          border: "none",
          opacity: 1,
          transition: "opacity 300ms ease-in-out",
        }}
        title="Email Preview"
        tabIndex={-1}
        onMouseDown={(e) => e.preventDefault()}
        onMouseUp={(e) => e.preventDefault()}
        onClick={(e) => e.preventDefault()}
        sandbox="allow-same-origin allow-scripts"
      />
    </Box>
  );
};

export default EmailPreview;
